import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MessageBar, MessageBarType, ProgressIndicator } from '@fluentui/react';
import { useAuth } from '@msrceng/auth';
import { useRedirectAfterDelayEffect } from './useRedirectAfterDelayEffect';
/**
 * This shows the user a loader when returning from B2C login.
 */
export const RedirectAuth = ({ label = 'Redirecting you, please wait...', }) => {
    const { error, errorSilent } = useAuth();
    useRedirectAfterDelayEffect();
    return (_jsxs(MessageBar, Object.assign({ messageBarType: MessageBarType.info, "aria-busy": true }, { children: [_jsx(ProgressIndicator, { label: label }), error && (_jsx(MessageBar, Object.assign({ messageBarType: MessageBarType.error }, { children: error.message }))), errorSilent && (_jsx(MessageBar, Object.assign({ messageBarType: MessageBarType.warning }, { children: errorSilent.message })))] })));
};
